module.exports = __webpack_public_path__ + "static/media/t_cur_02.896011bb.png";